// 261025 E3-P3f — hộp «Kết quả lần đẩy»: từng tập một dòng (nhãn + lý do), tên gốc còn sót trong chương vừa ghi. Dữ liệu = `workbench.handoffBatch`; chữ ở `handoffBatchView.ts`.
import React from 'react';
import { Alert, Button, Modal, Space, Typography } from 'antd';
import type { WorkbenchHandoffBatchView } from '../../../types/adaptationWorkbench';
import { batchOutcomeOf, batchProgressText, batchResultRows } from './handoffBatchView';
import { Pill } from './WbSlot';

const { Text } = Typography;

const TONE: Record<'ok' | 'warn' | 'bad' | 'muted', 'ok' | 'warn' | 'todo' | 'bad'> = { ok: 'ok', warn: 'warn', bad: 'bad', muted: 'todo' };

interface Props { batch: WorkbenchHandoffBatchView | null | undefined; open: boolean; onClose: () => void; onCancel?: (jobId: string) => void }

const HandoffBatchResults: React.FC<Props> = ({ batch, open, onClose, onCancel }) => {
  const rows = batchResultRows(batch?.results);
  const outcome = batchOutcomeOf(batch);
  const running = batch?.status === 'RUNNING';
  return (
    <Modal
      open={open && !!batch} title="Kết quả lần đẩy sang Chapters" onCancel={onClose} width={640}
      footer={(
        <Space>
          {running && onCancel && batch && <Button danger disabled={batch.cancelRequested} onClick={() => onCancel(batch.jobId)}>{batch.cancelRequested ? 'Đang dừng…' : 'Dừng đẩy'}</Button>}
          <Button type="primary" onClick={onClose}>Đóng</Button>
        </Space>
      )}
    >
      {batch && (
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          {running && <Alert type="info" showIcon message={batchProgressText(batch)} description="Việc chạy ở nền — có thể đóng hộp, kết quả cập nhật ở Sổ duyệt." />}
          {outcome && <Alert type={outcome.level} showIcon message={outcome.text} />}
          {batch.status === 'FAILED' && <Alert type="error" showIcon message="Việc đẩy dừng giữa chừng" description="Tập nào đã ghi thì giữ nguyên; bấm đẩy lại để làm tiếp phần còn lại." />}
          {rows.length > 0 && (
            <table className="wb-rb-table" aria-label="Kết quả từng tập">
              <thead><tr><th>Tập</th><th>Kết quả</th><th>Ghi chú</th></tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.ep} data-ep={r.ep}>
                    <td><b>{r.ep}</b></td>
                    <td><Pill tone={TONE[r.tone]}>{r.label}</Pill></td>
                    <td>
                      {r.detail && <Text type="secondary">{r.detail}</Text>}
                      {r.leaks && <div><Text type="warning">Còn tên gốc trong chương: {r.leaks}</Text></div>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {rows.length === 0 && !running && <Text type="secondary">Chưa có kết quả từng tập.</Text>}
        </Space>
      )}
    </Modal>
  );
};

export default HandoffBatchResults;
